import { lazy } from 'react'

export const TipBody =  lazy(() => import('./TipBody'))
export const TipDataBlock =  lazy(() => import('./TipDataBlock'))
export const PostTipDataBlock =  lazy(() => import('./PostTipDataBlock'))
export const TipHeader =  lazy(() => import('./TipHeader'))
export const TipAnalysis =  lazy(() => import('./TipAnalysis'))
export const TipBettingBar = lazy(() => import('./TipBettingBar'))
export { default as PremiumOverlay } from './PremiumOverlay'
